<template>
  <k-provider theme="material">
    <div class="app-root">
      <el-config-provider :locale="elementLocale" :size="'small'">
        <router-view />
      </el-config-provider>
    </div>
  </k-provider>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { kProvider } from 'konsta/vue'
import { useAuthStore } from '@/stores/auth'
import { useAppStore } from '@/stores/app'
import { getElementLocale, loadDbTranslations } from '@/i18n'

const authStore = useAuthStore()
const appStore = useAppStore()

const elementLocale = computed(() => getElementLocale(appStore.currentLang))

onMounted(async () => {
  await Promise.all([
    authStore.fetchUser(),
    loadDbTranslations(appStore.currentLang)
  ])
})
</script>

<style>
.app-root {
  min-height: 100vh;
  width: 100%;
}
</style>
